export default __webpack_public_path__ + "static/media/becomePartner.eae54d6f.webp";